function uInt8ToHex(n: number) {
  return n < 16 ? '0' + n.toString(16) : n.toString(16);
}

export function createHexId() {
  let array = new Uint8Array(16);
  crypto.getRandomValues(array);
  return Array.from(array, (n) => uInt8ToHex(n)).join('');
}
